<template>
  <div :class="{ 'add-select': add }">
    <el-select
      v-model="selected"
      :disabled="disabled"
      size="small"
      filterable
      remote
      clearable
      @change="handleChange"
      :remote-method="requestCustomers"
      :loading="loading"
      :placeholder="add ? '请选择或创建' : '请搜索并选择'"
      :popper-append-to-body="false"
      :class="{ long: !add }"
      style="width: 100%"
    >
      <el-option
        v-for="item in customers"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      ></el-option>
    </el-select>

    <el-button
      v-if="add"
      type="primary"
      plain
      class="ml-10"
      size="small"
      icon="el-icon-plus"
      @click="addCustomerFormVisible = true"
      >新建</el-button
    >
    <customer-former
      :category="category"
      :show.sync="addCustomerFormVisible"
      @createdCustomer="createdCustomer"
    ></customer-former>
  </div>
</template>

<script>
import { customerList } from '../../service/getData'
import { isMobile } from '@/util/index'
import CustomerFormer from '@/components/customer'
import store from '@/store/store'

export default {
  components: {
    CustomerFormer,
  },
  props: {
    val: '',
    dealerID: 0,
    filterCustomerID: 0,
    category: 0,
    area: {
      type: Array,
      default: () => [],
    },
    add: false,
    disabled: false,
  },
  watch: {
    val: function (v) {
      if (!v) {
        this.selected = ''
      } else {
        this.requestDefaultCustomer()
      }
    },
    // dealerID: function (v) {
    //   this.customerForm.dealer_id = v || 0
    // },
  },
  data() {
    return {
      isMobile,
      selected: '',
      customers: [],
      loading: false,
      addCustomerFormVisible: false,
    }
  },
  created() {
    if (this.val > 0) {
      this.requestDefaultCustomer()
    }
  },
  mounted() {
    this.$nextTick(() => {
      Array.from(document.getElementsByClassName('el-select')).forEach(
        (item) => {
          item.children[0].children[0].removeAttribute('readOnly')
          item.children[0].children[0].onblur = function () {
            let _this = this
            setTimeout(() => {
              _this.removeAttribute('readOnly')
            }, 200)
          }
        },
      )
    })
  },
  methods: {
    handleChange() {
      this.$emit('change', parseInt(this.selected) || 0)
      this.$emit(
        'info',
        this.selected
          ? this.customers.filter((item) => item.id == this.selected)[0]
          : null,
      )
    },
    createdCustomer(res) {
      this.customers.push(res)
      this.selected = res.id
      this.$emit('change', parseInt(this.selected) || 0)
      this.$emit('info', res)
    },
    async requestDefaultCustomer() {
      let res = await customerList({ customer_id: this.val, special_mark: -1 })
      this.customers = res.data.list.map((item) => {
        if (item.sap_code) {
          item.name += `（${item.sap_code}）`
        }
        return item
      })

      let that = this
      this.$nextTick(() => {
        that.selected = that.val
        that.handleChange()
      })
    },
    async requestCustomers(query) {
      if (query !== '') {
        this.loading = true
        let data = {
          name: query,
          dealer_id: this.dealerID || 0,
          category: this.category || 0,
          page: 0,
          size: 20,
          special_mark: -1,
        }
        let res = await customerList(data)
        this.loading = false
        res.data.list = res.data.list.filter(
          (item) => item.id != this.filterCustomerID,
        )
        this.customers = res.data.list.map((item) => {
          if (item.sap_code) {
            item.name += `（${item.sap_code}）`
          }
          return item
        })
      } else {
        this.customers = []
      }
    },
  },
}
</script>